// frontend/src/samkalp-admin/samkalpCentres.js
//
// Hardcoded centre list for Phase 1 (per the confirmed Samkalp multi-centre
// plan — no live backend-driven centre picker yet). Update this list
// manually as System Admin provisions new centres under the Samkalp parent
// tenant. Include the parent tenant itself so Samkalp's own top-level admin
// can log in the same way.
export const SAMKALP_CENTRES = [
    { slug: 'samkalp-ias', label: 'Samkalp IAS Academy (HQ)' },
];
